import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { optOutWithoutFeedback } from '../../../store/v3-opt-out/v3-opt-out.actions';
import { Button } from 'ui-components/components/button';

import messages from '../messages';
import style from '../app-header.module.less';
import { useCanViewV2Button } from '../../../hooks/use-can-view-v2-button';
import Global from '../../../store/global-selectors';

export const ReturnToV2Button = () => {
  const dispatch = useDispatch();
  const returnToLegacy = useCallback(() => {
    dispatch(optOutWithoutFeedback());
  }, [dispatch]);
  const canViewButton = useCanViewV2Button();
  const isV3OptOutProcessing = useSelector(Global.selectv3OptOutv3OptOutIsProcessing);

  if (!canViewButton) {
    return null;
  }

  return (
    <div className={style['beta-link-wrapper']}>
      <Button data-testid='return-to-v2-link' disabled={!!isV3OptOutProcessing} onClick={returnToLegacy} theme='white'>
        <FormattedMessage {...messages.betaHeader} />
      </Button>
    </div>
  );
};
